import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Input } from 'components/atoms/input';
import {
  deleteSpaceInProjectTemplate,
  updateSpaceInProjectTemplate,
} from 'data/templates/projects/actions';

export const NewSpace: FC<{ spaceId: number }> = ({ spaceId }) => {
  const dispatch = useDispatch();

  const handleOnEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const spaceName = e.currentTarget.value;

    dispatch(updateSpaceInProjectTemplate({ space: { spaceId, spaceName } }));
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === 27) {
      dispatch(deleteSpaceInProjectTemplate({ space: { spaceId } }));
    }
  };

  const handleOnBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const spaceName = e.currentTarget.value;

    if (!spaceName) {
      dispatch(deleteSpaceInProjectTemplate({ space: { spaceId } }));
    } else {
      dispatch(updateSpaceInProjectTemplate({ space: { spaceId, spaceName } }));
    }
  };

  return (
    <Input
      key="0"
      autoFocus
      size="small"
      onBlur={handleOnBlur}
      onPressEnter={handleOnEnter}
      onKeyDown={handleOnKeyDown}
    />
  );
};
